module.exports = __webpack_public_path__ + "static/media/filharmonia-narodowa-warszawa1-530x140-BOTGSvg6M0Vlo9GMpp8zbLCQPwxsl4.5af08cb3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/filharmonia-narodowa-warszawa1-530x140-BOTGSvg6M0Vlo9GMpp8zbLCQPwxsl4.webp
// module id = 636
// module chunks = 0